"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssortmentClusterAction = void 0;
var AssortmentClusterAction;
(function (AssortmentClusterAction) {
    AssortmentClusterAction["ASSORT"] = "ASSORT";
    AssortmentClusterAction["UNASSORT"] = "UNASSORT";
})(AssortmentClusterAction || (exports.AssortmentClusterAction = AssortmentClusterAction = {}));
